import { ValidationErrorKeys } from './validation-erros-keys';

export type PatternStruct = {
	pattern: string;
	openingCompletionChar: string;
	closingCompletionChar: string;
};

export const smallLangPattern = (
	value: any, // eslint-disable-line @typescript-eslint/no-explicit-any
	patterns: PatternStruct | Array<PatternStruct>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): { [k: string]: any } | null => {
	let toDetectPatterns = [];
	if (!Array.isArray(patterns)) {
		toDetectPatterns = [patterns];
	} else {
		toDetectPatterns = patterns;
	}

	let valid = true;
	let idx = 0;
	while (valid && idx < toDetectPatterns.length) {
		const patternUnderTest = new RegExp(toDetectPatterns[idx].pattern);

		if (patternUnderTest.test(value)) {
			const openChars = new RegExp(
				escapeReservedChars(toDetectPatterns[idx].openingCompletionChar)
			);

			const content = new RegExp(/.*/);

			const closeChars = new RegExp(
				escapeReservedChars(toDetectPatterns[idx].closingCompletionChar)
			);

			const toTest = concatRegex(
				patternUnderTest,
				openChars,
				content,
				closeChars
			);

			if (!toTest.test(value)) {
				valid = false;
			}
		}
		idx++;
	}

	return !valid
		? {
				[ValidationErrorKeys.IncompletePattern]: true,
		  }
		: null;
};

const escapeReservedChars = (val: string): string | RegExp => {
	if (val === '(') {
		return new RegExp(/\(/);
	}
	if (val === ')') {
		return new RegExp(/\)/);
	}
	return val;
};

const concatRegex = (...regex: Array<RegExp>): RegExp => {
	const val = regex.reduce((acc, currRegex) => acc + currRegex.source, '');

	return new RegExp(val);
};
